<template>
    <layout>
        <template #content>
            <div class="font-semibold text-lg">{{translate('abonnement')}}</div>
            <div class="my-6 px-5 py-2 border border-grey-300 rounded-xl font-medium flex items-center gap-4">
                <div class="size-14 bg-center bg-no-repeat -ml-2 box-content flex items-center justify-center" :class="['bg-' + checkoutStore.orderedPackage.abonnement.abonnement]">
                    <img :src="imageUrl" :alt="checkoutStore.orderedPackage.abonnement.abonnement" />
                </div>
                {{checkoutStore.orderedPackage.abonnement.abonnement.toTitleCase().replace('-', ' ')}}
            </div>

            <div class="mt-12  max-w-" v-if="isCw && checkoutStore.orderedPackage.abonnement.abonnement !== 'basic'">
                <div class="text-lg font-semibold">
                    {{translate('integraties')}}
                </div>
                <div class="mt-6">
                    <software-picker v-model="checkoutStore.chosenIntegration"></software-picker>
                </div>
            </div>
            <div v-else-if="!isCw">
                <div class="text-lg font-semibold mb-2">
                    {{translate('countries')}}
                </div>
                <country-selector></country-selector>
            </div>

            <div class="mt-12" v-if="chosenPackage.addOns.length > 0">
                <div class="text-lg font-semibold">
                    {{translate('addon_modal_title')}}
                </div>
                <p class="text-grey-800 mt-2 max-w-md">
                    {{translate('addon_modal_body')}}
                </p>
                <ul class="mt-6 space-y-3">
                    <li v-for="addon in chosenPackage.addOns" class="p-6 border border-grey-300 rounded-xl">
                        <div class="flex justify-between items-end">
                            <div>
                                <span class="mr-3 tablet:hidden"><i class="far text-primary-400" :class="[getAddOnIcon(addon)]"></i></span>
                                <span class="text-md tablet:text-base font-medium">{{translate('addon_' + addon.feature + '_title')}}</span>
                            </div>
                            <div>
                                <span class="text-md font-semibold mr-0.5">€ {{addon.price}}</span><span>{{translate('per_jaar')}}</span>
                            </div>
                        </div>
                        <div class="flex justify-between items-start gap-5 mt-5">
                            <ul class="text-grey-800 space-y-2">
                                <li class="flex gap-3"><i class="fas fa-check text-xs text-primary-400 mt-1"></i>{{translate('addon_' + addon.feature + '_usp_1')}}</li>
                                <li class="flex gap-3"><i class="fas fa-check text-xs text-primary-400 mt-1"></i>{{translate('addon_' + addon.feature + '_usp_2')}}</li>
                            </ul>
                            <div>
                                <button v-if="checkoutStore.chosenAddons.map(ad => ad.feature).includes(addon.feature)" class="btn btn-primary whitespace-nowrap" @click.prevent="checkoutStore.chosenAddons.removeBy(ca => ca.feature === addon.feature)">
                                    <i class="fas fa-check mr-1.5"></i> {{translate('toegevoegd')}}
                                </button>
                                <button v-else class="btn btn-primary btn-ghost" @click.prevent="checkoutStore.chosenAddons.push(addon)">
                                    {{translate('toevoegen')}}
                                </button>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </template>
    </layout>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {AddOn, Package} from "../../types";
import {Feature} from "../../../../types/dto/Feature";
import {useStore} from "../../store";
import Layout from "./layout.vue";
import SoftwarePicker from "../../../../components/software-picker.vue";
import CountrySelector from "../country-selector.vue";

export default defineComponent({
    name: "subscription",
    components: {CountrySelector, SoftwarePicker, Layout},
    data() {
        const checkoutStore = useStore();
        const chosenPackage = checkoutStore.allPackages.find(p => p.abonnement.abonnement === checkoutStore.orderedPackage.abonnement.abonnement)! as Package;
        return {
            checkoutStore: checkoutStore,
            chosenPackage
        }
    },
    computed: {
        isCw(): boolean {
            return this.checkoutStore.brand === "companyweb";
        },
        imageUrl(): string {
            return `/images-new/pricing/${this.checkoutStore.orderedPackage.abonnement.abonnement}.svg`;
        }
    },
    methods: {
        getAddOnIcon(addOn:AddOn): string {
            switch (addOn.feature) {
                case Feature.INTERNATIONAL_REPORTS:
                    return "fa-globe";
                case Feature.DATA_MARKETING:
                    return "fa-user-magnifying-glass";
                case Feature.KYC:
                    return "fa-shield-check";
                default:
                    return "";
            }
        }
    },
    mounted() {
        const params = new URLSearchParams(window.location.search);
        const countries = params.getAll("country");

        useStore().selectedCountries = useStore().countries.filter(c => countries.includes(c.code));
    }
})
</script>